import React from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Label,
  FormGroup,
  Form,
  Alert,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row
} from "reactstrap";
import cookie from 'react-cookies'
import { connect } from 'react-redux';
import "components/custom.css";
import Header from '../../../components/pteportal/Header';
import Footer from '../../../components/pteportal/Footer';
import API from "api.js";
import { Navigate, NavLink } from "react-router-dom";
import { setToken, setUser, setSub} from 'action/index.js';


class Forgot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      login:false,
      error:null,
      error_bag:null,
      otpflag:false
    };
  }
  componentDidMount() {
    document.body.classList.toggle("login-page");
  }
  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }

  postLogIn = async(e) => {
    
    this.setState({error_bag:null});
    e.preventDefault();
    let cred = {
      email: this.state.email,
      password: this.state.password,
    };
    var bodyFormData = new FormData();
    bodyFormData.set('email', this.state.email);
    let res = null;
    try{
      res = await API({
        method: 'POST',
        url: '/forgot',
        data: bodyFormData
      })
    }catch(error) {

        
    };
    if (res.status === 200) {
      this.setState({otpflag:true,error_bag:"OTP sent to your Email !"});
    }else if(res.response.status === 422){
      this.setState({error:res.response });
      let str = '';
      
      Object.values(this.state.error.data.errors).forEach((val) => { str += val[0]+'\
        '; })
      this.setState({error_bag:str});

    }
    else if (res.response.status === 402) {
      this.setState({error_bag:"Wrong credentials."});
    }
    
  }

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name] : value });
  };
  render() {
    const {token,setToken} = this.props;
    if (this.state.login) {
        return (<Navigate to="/admin/dashboard" replace />);
    }
    return (
      <>
      <section className="header-with-banner">
        <Header />
        <section id="hero about-us-page" className="d-flex align-items-center">
        <div className="container position-relative" data-aos="fade-up" data-aos-delay="100">
          <div className="row justify-content-center">
            <div className="col-xl-12 col-lg-12 mb-5">
              <h2 className="main-heading pt-5 text-center">Forgot Password </h2>
              <div className="breadcum">
                <ol className="breadcrumb primary-color text-center">
                    <li className="breadcrumb-item"><a className="white-text" href="#">Home</a></li>
                    <li className="breadcrumb-item active">Forgot Password</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
    </section>
        </section>
        <main id="main" className="avout-page"> 
      <div className=" ">
        
        
<section className="contentOuter">
  <div className="container">
    <div className="row">
      <div className="col-sm-7 loginForm">
        {this.state.error_bag && <Alert color="warning">{this.state.error_bag}</Alert>}
          <div className="fieldOuter">
            <Input 
                placeholder="Email"
                type="text"
                name="email"
                value={this.state.email}
                onChange={(e) => { this.changeInput(e)} }
              />
              
          </div>
          
          <div className="rememberForgot">
            <div className="rememberMe">
              <input type="checkbox" name="" />
              <span>Remember me</span>
            </div>
            <div className="forgotPwd">
              <NavLink className="mt-5" to='/auth/login'><span>Back</span></NavLink>
            </div>
          </div>
          <div className="fieldOuter text-right">
            <Button
              className="themeBtn"
              onClick={(e) => {this.postLogIn(e)}}
            >
              Submit
            </Button>
            {this.state.otpflag && <NavLink to="/auth/resetPassword">Got OTP?</NavLink>}
          </div>
      </div>
      <div className="col-sm-5 registerLink text-center">
        <h3>New User?</h3>
        <p>Register now to obtain your<br /> Free Mock Test Material</p>
        <NavLink to="/auth/register" className="themeBtn blueBtn">Register</NavLink>
      </div>
    </div>
  </div>
</section>
        
      </div>
      </main>
      </>
    );
  }
}

export default Forgot;
